import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';

import { ExclamationCircleOutline as ExclamationCircle } from '@aslanpay/portal-common-lib';

import useSignOut from 'app/hooks/useSignOut';

import { NotAuthorizedModalProps } from './types';

function NotAuthorizedModal({ isOpen, onClose }: NotAuthorizedModalProps) {
  const { mutate: signOut } = useSignOut();

  const handleOk = () => {
    signOut();
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="lg"
      isCentered
      closeOnEsc={false}
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <HStack>
            <ExclamationCircle color="system.error" boxSize="24px" />
            <Text as="h6">Your session expired!</Text>
          </HStack>
        </ModalHeader>
        <ModalBody>
          <Text color="brand.mutedPurple" textStyle="body">
            We cannot perform this action because your session expired. You will be redirected to
            the login page after this.
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button size="sm" onClick={handleOk}>
            Okay
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default NotAuthorizedModal;
